require('./components/sequence-editor');

import $ from 'jquery';
require('selectize');

$('select').selectize();
